import React, { useMemo, useRef } from 'react';
import useDuperbrowseScrollRestoration from '../../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import RowWrapper from './RowWrapper';
var HiddenRow = function (_a) {
    var items = _a.items, width = _a.width, height = _a.height, _b = _a.extraItemHeight, extraItemHeight = _b === void 0 ? 0 : _b;
    var itemIds = useMemo(function () { return items.map(function (item) { return item.dto.duperbrowseItemId; }); }, [items]);
    var rowRef = useRef(null);
    useDuperbrowseScrollRestoration(itemIds, rowRef);
    return (React.createElement(RowWrapper, { style: {
            width: width,
            height: height + extraItemHeight,
        }, ref: rowRef }));
};
HiddenRow.displayName = 'HiddenRow';
export default React.memo(HiddenRow);
//# sourceMappingURL=HiddenRow.js.map